import React from 'react'
import List from '@mui/material/List';
import { Switch} from '@mui/material';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { styled } from '@mui/material/styles';
import Input from '@mui/material/Input';

const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
    '&:active': {
        '& .MuiSwitch-thumb': {
            width: 15,
        },
        '& .MuiSwitch-switchBase.Mui-checked': {
            transform: 'translateX(9px)',
        },
    },
    '& .MuiSwitch-switchBase': {
        padding: 2,
        '&.Mui-checked': {
            transform: 'translateX(12px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: theme.palette.mode === 'dark' ? '#177ddc' : '#ed6c02',
            },
        },
    },
    '& .MuiSwitch-thumb': {
        boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
        width: 12,
        height: 12,
        borderRadius: 6,
        transition: theme.transitions.create(['width'], {
            duration: 200,
        }),
    },
    '& .MuiSwitch-track': {
        borderRadius: 16 / 2,
        opacity: 1,
        backgroundColor:
            theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
        boxSizing: 'border-box',
    },
}));


const ListFScrol = styled(List)(({ theme }) => ({

    // Some CSS
    overflowY: "auto",
    flexDirection: "row",
    margin: 0,
    padding: 0,
    listStyle: "none",
    height: "100%",
    scrollbarWidth: "thin",
    '&::-webkit-scrollbar': {
        width: '0.2em'
    },
    '&::-webkit-scrollbar-track': {
        boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
        webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)'
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(0,0,0,.1)',
        outline: '1px solid rgb(0 0 0 / 54%)'
    }
    ,
}));

function SortArray(x, y){
    return x.nameValeu.localeCompare(y.nameValeu);
}

function DisplayTypeCompanentF(props) {
    const [checked, setChecked] = React.useState(props.checked);
    const [searshParams, setSearchParams] = React.useState("");
    const [openBlock, setOpenBlock] = React.useState(true);

    const handleToggle = (value, code) => () => {

        if (checked.hasOwnProperty(code)) {

            let currentIndex = checked[code].indexOf(String(value));
            if (currentIndex === -1) {
                checked[code].push(String(value));
            } else {
                checked[code].splice(currentIndex, 1);
            }


        }
        else {
            if (code != "")
                checked[code] = [String(value)];
        }


        setChecked(checked);
        props.setCheckenFiltr(checked);
        props.submitForm();
    };

    const RemoveChecks = () => {
        console.log(props.code);
        checked[props.code] = [];
        setChecked(checked);
        props.setCheckenFiltr(checked);
        props.submitForm();
    }
    const filteredItems = props.propertyvalue.filter(
        el =>
            el.nameValeu.toLowerCase().search(searshParams.toLowerCase()) !== -1
    );

    const itemsToDisplay = searshParams ? filteredItems : props.propertyvalue;

    return (
        <>

            {/* <Typography sx={{ mt: 1, mb: 0 }} variant="h6" component="div">
                {props.name}
                {checked[props.code]?.length >= 1 && (
                    <Button variant="text" size="small" onClick={RemoveChecks}>Очистить</Button>
                )}
            </Typography> */}

            {openBlock &&

                (

                    <>
                        {props.propertyvalue.length > 9 && (
                            <Input type="text"
                                className="form-control mb-4"
                                placeholder="Поиск..."
                                onChange={(e) => setSearchParams(e.target.value.toLocaleLowerCase())}
                                color="warning"
                            />
                        )}
                        <ListFScrol
                            sx={{ width: '100%', maxWidth: '100%', maxHeight: '100%', bgcolor: 'background.paper', overflowY: "initial", height: 'auto' }}
                            
                        >
                            {!filteredItems.length && (
                                <div>По вашему запросу не чего не найдено</div>
                            )}

                            {itemsToDisplay.sort(SortArray)
                                .map((value, i) => {
                                    const labelId = `checkbox-list-label-${value.ID}`;

                                    return (

                                        <ListItem
                                            key={i}
                                            
                                            disablePadding
                                        >
                                            <ListItemButton role={undefined} onClick={handleToggle(String(value.ID), props.code)} dense>
                                                <ListItemIcon>
                                                <AntSwitch
                                                checked={checked[props.code] ? checked[props.code].indexOf(String(value.ID)) !== -1 : false}
                                                color="warning"
                                                inputProps={{ 'aria-label': 'ant design' }}

                                            />
                                                    {/* <Checkbox
                                                        edge="start"
                                                        checked={checked[props.code] ? checked[props.code].indexOf(String(value.ID)) !== -1 : false}
                                                        tabIndex={-1}
                                                        disableRipple
                                                        inputProps={{ 'aria-labelledby': labelId }}
                                                    /> */}
                                                </ListItemIcon>
                                                <ListItemText id={labelId} primary={`${value.nameValeu}  ${value.countfiltr}`} />
                                            </ListItemButton>
                                        </ListItem>
                                    );
                                })}
                        </ListFScrol>

                    </>
                )

            }




        </>
    )
}

export default DisplayTypeCompanentF;
